import { headerHeight } from './helpers'

const scrollProgress = () => {
  let scrollPos
  const update = () => {
    const totalScrollHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight
    document.documentElement.style.setProperty(
      '--scroll-progress',
      scrollPos / totalScrollHeight
    )
    document.documentElement.style.setProperty(
      '--first-screen-opacity',
      1 - Math.min(scrollPos / (window.innerHeight - headerHeight()), 1)
    )
  }

  const animationFrame = () => {
    const newScrollPos = window.scrollY || document.documentElement.scrollTop
    if (newScrollPos !== scrollPos) {
      scrollPos = newScrollPos
      update()
    }
    requestAnimationFrame(animationFrame)
  }
  animationFrame()

  // const throttledUpdate = throttle(update, 100)
  // // window.addEventListener('scroll', throttledUpdate)
  // requestAnimationFrame(() => {
  //   update()
  // })
  // update()
}

export default scrollProgress
